import { Entity } from "./entity";
import { Company } from "./company";


export class Agency extends Entity {    
    CompanyId: number;
    Name: string;
    VatNumber: string;
    Code: string;
    CityCode: string;
    ProvinceCode: string;
    Address?: string;    
    Cap?: string;    
    Error?: string;
    IsDisabled: boolean;
    Disabled?: Date | null;
    DescCompany?: string;
    State: string;
    // @association(Company, 'companyId', (id: string | number) => cache(LookupKey.COMPANY, id))
    Company?: Company;
    PrincipalCounter: number;
    // @association(PrincipalAuth)
    // principalAuth: PrincipalAuth[];
    // @association(PrincipalCertificate)
    // principalCertificate: PrincipalCertificate[];

    // constructor(data?: any) {
    //     super()
    //     this.init(data);      
    // }

    static newItem(): Agency {

        let item = new Agency();
        item.Id = 0;
        item.Disabled = null;
        return item;
    }

}

export class AgencySearchModel extends Entity /*implements Pagination*/ {
    Name?: string;
    VatNumber?: string;
    Address?: string;
    CompanyId: number;
    Code?: string;
    Take?: number;
    QueryName: string | null;
    QueryId: number | null;
    PageDirection?: string;
    // pager: Pager = <Pager> {
    //     take: 100,
    //     orderBy: 'id'
    // };
}